export default "/images/calendar2.svg?f6fac44696a110cb33d02562d5660712";